import { useState, useEffect } from 'react';
import { notNullOrEmpty } from './../../utils/validators';

export const FloatingTextInput = ({ label, text, updateCallback, className, required, validatorFn, readOnly, onClick, onBlur }) => {

    const isValidLength = () => readOnly || (!!required ? notNullOrEmpty(text) : true);
    const isValidFormat = () => readOnly || (isValidLength() && validatorFn(text));

    const [valueChanged, setValueChanged] = useState(notNullOrEmpty(text));
    const [inputValue, setInputValue] = useState("");

    useEffect(() => {
        setValueChanged(value => value || notNullOrEmpty(text));
        setInputValue(text ? text : "");
    }, [text]);

    const validInput = () => {

        if (!valueChanged || readOnly) {
            return true;
        }

        let valid = true;
        valid &&= isValidFormat();
        valid &&= valueChanged && !!validatorFn ? validatorFn(text) : true;
        return valid;
    };

    const style = required && validInput() ? {} : (required || !!inputValue) && !validInput() ? {
        borderColor: "red",
        color: "red"
    } : {};

    const boxShadow = required && validInput() ? {} : (required || !!inputValue) && !validInput() ? {
        boxShadow: '1px 2px 9px rgba(244, 170, 185, 1)'
    } : {};

    return (
        <>
            <div className={`form-floating mb-3 mb-md-0 ${className}`}>
                <input onClick={() => { return onClick ? onClick() : () => { } }} onBlur={onBlur} readOnly={readOnly} required={required} style={validInput() ? style : { ...style, ...boxShadow }} type="text" className={`form-control fs-15px ${validInput() ? 'text-black-900' : 'text-red'} `} id="text" placeholder="Enter Value" value={inputValue} onChange={e => updateCallback(e.target.value)} />
                <label htmlFor="text" className="d-flex align-items-center fs-13px text-black">{label ?? "Text Value"}</label>
            </div>
            {required && !validInput() && <div className='row'>
                <div className='mt-5px' style={isValidLength() ? { display: "none" } : style} >Value is required</div>
                <div className='mt-5px' style={isValidFormat() ? { display: "none" } : style} >Value format is invalid</div>
            </div>}
        </>
    );
};